import { render, staticRenderFns } from "./VersionAssetsSettings.vue?vue&type=template&id=2d98699f&lang=pug&"
import script from "./VersionAssetsSettings.vue?vue&type=script&lang=js&"
export * from "./VersionAssetsSettings.vue?vue&type=script&lang=js&"
import style0 from "./VersionAssetsSettings.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports